'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactModal = require('react-modal');

var _reactModal2 = _interopRequireDefault(_reactModal);

var _reactPlayer = require('react-player');

var _reactPlayer2 = _interopRequireDefault(_reactPlayer);

var _VideoModal = require('./VideoModal.css');

var _VideoModal2 = _interopRequireDefault(_VideoModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VideoModal = (_dec = (0, _reactCssModules2.default)(_VideoModal2.default, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(VideoModal, _Component);

  function VideoModal(props) {
    (0, _classCallCheck3.default)(this, VideoModal);

    var _this = (0, _possibleConstructorReturn3.default)(this, (VideoModal.__proto__ || (0, _getPrototypeOf2.default)(VideoModal)).call(this, props));

    _this.openModal = function () {
      _this.setState({ modalOpen: true });
    };

    _this.closeModal = function () {
      _this.setState({ modalOpen: false });
    };

    _this.state = {
      modalOpen: false
    };
    return _this;
  }

  (0, _createClass3.default)(VideoModal, [{
    key: 'render',
    value: function render() {
      if (!this.props.vimeoId) {
        return null;
      }

      return _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement(
          'span',
          { onClick: this.openModal, styleName: 'modal-opener' },
          this.props.children
        ),
        _react2.default.createElement(
          _reactModal2.default,
          {
            isOpen: this.state.modalOpen,
            onRequestClose: this.closeModal,
            contentLabel: 'Video player',
            style: {
              overlay: {
                backgroundColor: 'rgba(0, 0, 0, 0.75)'
              },
              content: {
                position: 'absolute',
                top: '50%',
                left: 0,
                right: 0,
                bottom: 'auto',
                marginLeft: 'auto',
                marginRight: 'auto',
                width: '640px',
                maxWidth: '90%',
                border: '0px',
                background: '#fff',
                overflow: 'visible',
                WebkitOverflowScrolling: 'touch',
                borderRadius: 0,
                outline: 'none',
                transform: 'translateY(-50%)',
                padding: 0
              }
            } },
          _react2.default.createElement(
            'div',
            { styleName: 'family-modal-wrap' },
            _react2.default.createElement(
              'div',
              { styleName: 'family-modal-flex' },
              _react2.default.createElement(
                'div',
                { styleName: 'media-react-player-wrap' },
                _react2.default.createElement(_reactPlayer2.default, {
                  url: 'https://vimeo.com/' + this.props.vimeoId,
                  volume: 0.5,
                  playing: true,
                  loop: true
                })
              )
            ),
            _react2.default.createElement(
              'div',
              {
                styleName: 'family-modal-close-wrap',
                onClick: this.closeModal
              },
              _react2.default.createElement('div', {
                styleName: 'family-modal-close',
                className: 'fa fa-times'
              })
            )
          )
        )
      );
    }
  }]);
  return VideoModal;
}(_react.Component), _class2.propTypes = {
  vimeoId: _react.PropTypes.string.isRequired
}, _temp)) || _class);
exports.default = VideoModal;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/VideoModal/VideoModal.js
// module id = 1391
// module chunks = 0